import React, { useState, useEffect } from 'react';
import { format } from 'date-fns';

const RawDataLog = () => {
  const [historyData, setHistoryData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchHistoryData = async () => {
      try {
        setLoading(true);
        const response = await fetch('/api/pet-history');
        
        if (!response.ok) {
          throw new Error(`HTTP error! status: ${response.status}`);
        }
        
        const data = await response.json();
        setHistoryData(data);
        setLoading(false);
      } catch (err) {
        console.error('Error fetching history data:', err);
        setError('Failed to load history data. Please try again later.');
        setLoading(false);
      }
    };

    fetchHistoryData();
  }, []);

  if (loading) {
    return (
      <div className="flex items-center justify-center py-12">
        <div className="text-center">
          <div className="animate-spin rounded-full h-8 w-8 border-t-2 border-b-2 border-primary-500 mx-auto"></div>
          <p className="mt-4 text-sm font-pixel text-primary-400">Loading data...</p>
        </div>
      </div>
    );
  }

  if (error) {
    return (
      <div className="text-center text-danger-500 py-12">
        <p className="font-mono">{error}</p>
      </div>
    );
  }

  // Sort data by timestamp (newest first)
  const sortedData = [...historyData].sort((a, b) => b.timestamp - a.timestamp);

  return (
    <div className="py-6 px-4 max-w-full mx-auto bg-dark-500">
      <header className="text-center mb-6">
        <h1 className="text-2xl font-pixel text-primary-400 mb-2">Raw Network Data Log</h1>
        <p className="text-sm text-accent-400 font-mono">
          Last 24 hours of 5-minute interval data entries ({sortedData.length} records)
        </p>
      </header>

      <div className="arcade-container mb-6 overflow-x-auto">
        <table className="w-full text-xs font-mono">
          <thead>
            <tr className="text-primary-300 border-b border-dark-600">
              <th className="py-1 px-1 text-left">Time</th>
              <th className="py-1 px-1 text-left">State</th>
              <th className="py-1 px-1 text-right">Hgr</th>
              <th className="py-1 px-1 text-right">Eng</th>
              <th className="py-1 px-1 text-right">Hap</th>
              <th className="py-1 px-1 text-right">N/m</th>
              <th className="py-1 px-1 text-right">N.B</th>
              <th className="py-1 px-1 text-right">N.R</th>
              <th className="py-1 px-1 text-right">Z/m</th>
              <th className="py-1 px-1 text-right">Z.B</th>
              <th className="py-1 px-1 text-right">Z.R</th>
              <th className="py-1 px-1 text-right">MT</th>
              <th className="py-1 px-1 text-right">MT.B</th>
              <th className="py-1 px-1 text-right">MT.R</th>
            </tr>
          </thead>
          <tbody>
            {sortedData.map((entry) => (
              <tr key={entry.timestamp} className="border-b border-dark-700 hover:bg-dark-600">
                <td className="py-1 px-1">{format(new Date(entry.timestamp), 'MM-dd HH:mm')}</td>
                <td className="py-1 px-1">{entry.stats.currentState}</td>
                <td className="py-1 px-1 text-right">{entry.stats.hunger}%</td>
                <td className="py-1 px-1 text-right">{entry.stats.energy}%</td>
                <td className="py-1 px-1 text-right">{entry.stats.happiness}%</td>
                <td className="py-1 px-1 text-right">{entry.metrics.notes.currentRate.toFixed(1)}</td>
                <td className="py-1 px-1 text-right">{entry.metrics.notes.baseline.toFixed(1)}</td>
                <td className="py-1 px-1 text-right">{entry.metrics.notes.baseline > 0 ? (entry.metrics.notes.currentRate / entry.metrics.notes.baseline).toFixed(1) : '1.0'}</td>
                <td className="py-1 px-1 text-right">{Number(entry.metrics.zaps.currentRate).toFixed(1)}</td>
                <td className="py-1 px-1 text-right">{Number(entry.metrics.zaps.baseline).toFixed(1)}</td>
                <td className="py-1 px-1 text-right">{entry.metrics.zaps.baseline > 0 ? (entry.metrics.zaps.currentRate / entry.metrics.zaps.baseline).toFixed(1) : '1.0'}</td>
                <td className="py-1 px-1 text-right">{Math.round(entry.metrics.moscowTime.current)}</td>
                <td className="py-1 px-1 text-right">{Math.round(entry.metrics.moscowTime.baseline)}</td>
                <td className="py-1 px-1 text-right">{entry.metrics.moscowTime.baseline > 0 ? (entry.metrics.moscowTime.current / entry.metrics.moscowTime.baseline).toFixed(1) : '1.0'}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
      
      <div className="text-center">
        <a 
          href="/"
          className="inline-block px-4 py-2 bg-primary-600 text-white font-pixel rounded hover:bg-primary-700 transition-colors"
        >
          Back to Dashboard
        </a>
      </div>
      
      <footer className="text-center text-gray-500 text-xs font-mono mt-8 mb-4">
        <p>Nostrie monitors the health of the Nostr network in real-time.</p>
        <p className="mt-2">© {new Date().getFullYear()} Nostrie Project</p>
      </footer>
    </div>
  );
};

export default RawDataLog; 